module.exports = __webpack_public_path__ + "img/NG.93ea8802.svg";